import { useMutation, useQueryClient } from 'react-query';
import {
  likeAdaptedFictionEditionComment,
  type LikeAdaptedFictionEditionCommentResponse
} from '../../services/commentsAndLikeService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useLikeAdaptedFictionEditionComment({
  adaptedFictionEditionId,
  commentId
}: {
  adaptedFictionEditionId: string;
  commentId: string;
}) {
  const queryClient = useQueryClient();
  return useMutation<LikeAdaptedFictionEditionCommentResponse, Error>({
    mutationFn: () => likeAdaptedFictionEditionComment({ adaptedFictionEditionId, commentId }),
    onSuccess: () => {
      queryClient.invalidateQueries(
        SCENE_QUERY_KEYS.adaptedFictionEditionComments(adaptedFictionEditionId)
      );
      queryClient.invalidateQueries(
        SCENE_QUERY_KEYS.sceneCommentDetail(adaptedFictionEditionId, commentId)
      );
    }
  });
}
